import { useState } from 'react';
import { postRatingsResource } from '../services/api';

export const useRatings = () => {
    // States
    const [isCalificated, setIsCalificated] = useState(false);

    // Functions
    const postRatings = async (id, value) => {
        const body = {
            type: 'recurso',
            item_id: id,
            qualification: value,
        };

        handleCalificated(true);

        try {
            const response = await postRatingsResource(body);
            return response;
        } catch (error) {
            console.error('Error posting ratings:', error);
            throw error;
        }
    };

    const handleCalificated = (value) => {
        setIsCalificated(value);
    };

    return {
        isCalificated,
        postRatings,
        handleCalificated,
    };
};
